
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Receipts": () => {
return Promise.all(/*  | __federation_expose_Receipts */ [__webpack_require__.e("558"), __webpack_require__.e("849"), __webpack_require__.e("894"), __webpack_require__.e("476")]).then(() => (() => (__webpack_require__(7627))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };